import { render, staticRenderFns } from "./GameCollectionCard.vue?vue&type=template&id=5fad830b&scoped=true&"
import script from "./GameCollectionCard.vue?vue&type=script&lang=ts&"
export * from "./GameCollectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./GameCollectionCard.vue?vue&type=style&index=0&id=5fad830b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad830b",
  null
  
)

export default component.exports